import React, { useState, useEffect } from 'react';
import { User } from 'lucide-react';
import './Header.css';

interface HeaderProps {
  onNavigate?: (path: string) => void;
}

const Header: React.FC<HeaderProps> = ({ onNavigate }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY < 10) {
        // Always show header at the very top
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down and past 100px - hide header
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY) {
        // Scrolling up - show header
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <header className={`header ${isVisible ? 'header-visible' : 'header-hidden'}`}>
      <div className="header-content">
        <div className="header-left">
          <div 
            className="header-logo"
            onClick={() => onNavigate && onNavigate('/')}
            style={{ cursor: 'pointer' }}
          >
            <span style={{ color: 'white', fontSize: '16px', fontWeight: '600' }}>Remi</span>
          </div>
        </div>
        <div className="header-right">
          <button
            className="header-pricing-link"
            onClick={() => onNavigate && onNavigate('/pricing')}
          >
            <span>Pricing</span>
          </button>
          <button
            className="header-signin-button"
            onClick={() => onNavigate && onNavigate('/login')}
          >
            <User size={14} />
            <span>Sign In</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;